import { render, staticRenderFns } from "./CalendarFooter.vue?vue&type=template&id=2d4df89c&"
import script from "./CalendarFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarFooter.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4df89c')) {
      api.createRecord('2d4df89c', component.options)
    } else {
      api.reload('2d4df89c', component.options)
    }
    module.hot.accept("./CalendarFooter.vue?vue&type=template&id=2d4df89c&", function () {
      api.rerender('2d4df89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/components/CalendarFooter.vue"
export default component.exports